export const convertCamelCaseToWords = (camelCaseStr) => {
  return camelCaseStr
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .toLowerCase();
};
